import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'sh-item-upload',
    templateUrl: './item-upload.component.html',
    styleUrls: ['./item-upload.component.scss'],
    standalone: true
})
export class ShItemUploadComponent {
    @ViewChild('fileInput', { static: true }) fileInput!: ElementRef;
    @ViewChild('multiFileInput', { static: true }) multiFileInput!: ElementRef;
    @Input() multiFileSelect: boolean = true;
    @Output() selection: EventEmitter<FileList> = new EventEmitter<FileList>();

    click(): void {
        if (this.multiFileSelect) {
            this.multiFileInput?.nativeElement.click();
        } else {
            this.fileInput?.nativeElement.click();
        }
    }

    public fileInputChange(event: Event): void {
        const fileList: FileList = (event.target as HTMLInputElement).files as FileList;
        if (fileList) {
            this.selection.emit(fileList);
        }
    }
}
